module.exports = __webpack_public_path__ + "img/traditional-clothing.79726c8e.webp";